module.exports = __webpack_public_path__ + "img/usdt.ca5454da.png";